import { css } from 'styled-components';

/**
 * Layout for pages with TopBarRedesigned (or another header that owns
 * --native-safe-area-top). Matches DO InvoicesPage / Talent InvoicesList:
 * header stays fixed; only the body scrolls — content never slides under the
 * Dynamic Island.
 */
export const nativePageShell = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  background-color: #fff;
`;

/** Scrollable region below a non-scrolling header. Do not add padding-top safe area here. */
export const nativePageScrollRegion = css`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
`;
